/**
 * Inline custom date range picker — two date inputs shown when
 * the period filter is set to 'custom'.
 */
function CustomDateRangePicker({ startDate, endDate, onChange }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-[12px] text-slate-500">From</span>
      <input
        type="date"
        value={startDate}
        onChange={(e) => onChange({ startDate: e.target.value, endDate })}
        className="h-9 rounded-lg border border-slate-200 bg-white px-3 text-[13px] text-slate-700 outline-none focus:border-slate-400"
      />
      <span className="text-[12px] text-slate-500">To</span>
      <input
        type="date"
        value={endDate}
        onChange={(e) => onChange({ startDate, endDate: e.target.value })}
        className="h-9 rounded-lg border border-slate-200 bg-white px-3 text-[13px] text-slate-700 outline-none focus:border-slate-400"
      />
    </div>
  )
}

export default CustomDateRangePicker
